exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3kMSo5aP{height:0;width:0;visibility:hidden}._1uRlS_lc{float:left;position:relative;font-weight:700;font-size:14px;line-height:21px;letter-spacing:.42px}._2FgiejR4{-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;width:60px;height:25px;border-radius:100px;position:relative;-webkit-transition:background-color .2s;transition:background-color .2s;float:right;top:-3px;margin:0}.XZxQx2rZ ._2FgiejR4{background:#4b55f6}.FgCBc8mL ._2FgiejR4{background:#f1f3fd}._2FgiejR4 ._1e2KJChN{content:\"\";position:absolute;top:2px;left:2px;width:20px;height:20px;border-radius:20px;-webkit-transition:.2s;transition:.2s;background:#fff;-webkit-box-shadow:0 0 2px 0 hsla(0,0%,4%,.29);box-shadow:0 0 2px 0 hsla(0,0%,4%,.29)}._3kMSo5aP:checked+._2FgiejR4 ._1e2KJChN{left:98%;-webkit-transform:translateX(-100%);transform:translateX(-100%)}._2FgiejR4:active ._1e2KJChN{width:40px}", ""]);

// exports
exports.locals = {
	"react-switch-checkbox": "_3kMSo5aP",
	"react-switch-text": "_1uRlS_lc",
	"react-switch-label": "_2FgiejR4",
	"react-switch-on": "XZxQx2rZ",
	"react-switch-off": "FgCBc8mL",
	"react-switch-button": "_1e2KJChN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/react-toolbox-extended/toggle.less
// module id = 1264
// module chunks = 1